export const SidePanel = 'atlantis-side-panel';
export const SidePanelHeaderTitle = 'atlantis-side-panel-header-title';
export const SidePanelHeaderStatus = 'atlantis-side-panel-header-status';